// React Imports
import { createContext, useContext, useState, useCallback } from 'react';

// Module Imports
import debounce from 'lodash.debounce';

// Context Imports
import { useEditor } from './EditorContext';

const MultiTabEditorContext = createContext()

export function MultiTabEditorProvider({ children }) {

    const { setUserFiles, socket } = useEditor();

    const [tabs, setTabs] = useState([]);
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const [fileTree, setFileTree] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);


    const handleFileClick = (file) => {
        const existingTabIndex = tabs.findIndex((tab) => tab.path === file.path);

        if (existingTabIndex === -1) {

            setTabs([...tabs, file])
            setSelectedTabIndex(tabs.length)
        } else {
            setSelectedTabIndex(existingTabIndex);
        }
    }

    const handleTabChange = (event, newValue) => {
        setSelectedTabIndex(newValue)
        setSelectedItem(tabs[newValue])
    }

    const removeTab = (filePath) => {
        setTabs(tabs.filter((tab) => tab.path !== filePath));

        //Automatically selected next tab, if current tab was last select previous one
        const newSelectedTabIndex = selectedTabIndex >= tabs.length - 1 ? tabs.length - 2 : selectedTabIndex;
        console.log(newSelectedTabIndex)
        setSelectedTabIndex(newSelectedTabIndex);
        setSelectedItem(tabs[newSelectedTabIndex])
    }

    const saveFile = useCallback(
        debounce((filePath, content) => {
            socket.emit('file:save', { filePath, content }); // Emit saveFile event with file data
            socket.on('file:save:success', () => {
                setUserFiles((prev) => ({ ...prev, [filePath]: content }))
                // console.log(`Saving file: ${filePath}`);
            })
        }, 500), // 500ms debounce delay
        [socket]
    );

    const handleEditorChange = (newValue) => {
        const currentTab = tabs[selectedTabIndex];
        if (!currentTab) return;

        // Update the tab content in state
        const updatedTabs = [...tabs];
        updatedTabs[selectedTabIndex].content = newValue;
        setTabs(updatedTabs);

        // Save file with debounce
        saveFile(currentTab.path, newValue);
    };

    const value = {
        tabs,
        setTabs,
        selectedTabIndex,
        setSelectedTabIndex,
        fileTree,
        setFileTree,
        handleFileClick,
        handleTabChange,
        removeTab,
        handleEditorChange,
        selectedItem,
        setSelectedItem
    };
    return (
        <MultiTabEditorContext.Provider value={value}>
            {children}
        </MultiTabEditorContext.Provider>
    )
}

export function useMultiTabEditor() {
    const context = useContext(MultiTabEditorContext);
    if (!context) {
        throw new Error('useMultiTabEditor must be used within an MultiTabEditorProvider');
    }
    return context;
}
